// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rotate-icon[data-v-2041db32] {\n  animation: rotate-continuously-2041db32 1s infinite alternate;\n}\n@keyframes rotate-continuously-2041db32 {\n0% {\n    transform: rotate(0deg) scale(1);\n}\n100% {\n    transform: rotate(360deg) scale(1.5);\n}\n}", ""]);
// Exports
module.exports = exports;
